import { AddInvestmentFormValues } from "../types";
import { useRequest } from "../../../hooks/useRequest";
import { useState } from "react";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import routes from "../../../routes";

function useAddInvestmentForm(clientId: string) {
  const { fetch, response, error, loading } = useRequest();
  const [isEditing, setEditing] = useState(false);
  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "Investment has been sccessfully added!",
  );

  const handleSubmit: (
    form: AddInvestmentFormValues,
    id: string,
  ) => Promise<void> = async (form: AddInvestmentFormValues) => {
    const payload = {
      solutionId: form["id"],
      totalInvested: form["quantity"],
      unit: form["unit"],
      note: form["note"],
      notifyClient: form["notifyClient"],
    };

    const result = await fetch(
      "POST",
      routes.api.investment.forClient({ clientId }),
      payload,
    );

    if (result && result.status === 200) {
      setEditing(false);
    }
  };

  return {
    handleSubmit,
    alert,
    setAlert,
    isEditing,
    setEditing,
    formLoading: loading,
  };
}

export default useAddInvestmentForm;
